module.exports = __webpack_public_path__ + "img/ru.2334547e.png";